export default __webpack_public_path__ + "static/media/pro_black.525ea55c.svg";